import { Collapsible } from "@base-ui/react/collapsible";
import type { ReactNode } from "react";
import { cx } from "./cx.js";
import { ChevronDownIcon } from "./icons.jsx";

export interface DisclosureProps {
  /** The always-visible label that toggles the panel. */
  summary: ReactNode;
  defaultOpen?: boolean;
  className?: string;
  children: ReactNode;
}

/**
 * Base UI Collapsible styled as a Diotia disclosure — the owned replacement for
 * `<details>`/`<summary>`, whose native marker and typography we cannot theme.
 */
export function Disclosure({ summary, defaultOpen, className, children }: DisclosureProps) {
  return (
    <Collapsible.Root defaultOpen={defaultOpen} className={cx("dt-disclosure", className)}>
      <Collapsible.Trigger className="dt-disclosure__trigger">
        <ChevronDownIcon className="dt-disclosure__icon" />
        <span className="dt-disclosure__summary">{summary}</span>
      </Collapsible.Trigger>
      <Collapsible.Panel className="dt-disclosure__panel">
        <div className="dt-disclosure__content">{children}</div>
      </Collapsible.Panel>
    </Collapsible.Root>
  );
}
